import { Link, useLocation, useNavigate } from "react-router-dom";

import { Card } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";

const EmptyProjectCard = ({ content = null }) => {
  return (
    <Link to="/produce/all-projects/create">
      <SuiBox
        sx={{
          border: "1px dashed",
          borderWidth: ({ borders }) => borders.borderWidth[2],
          borderColor: ({ borders }) => borders.borderColor,
          cursor: "pointer",
          height: 120,
          width: "100%",
          borderRadius: 4,
        }}
      >
        {content ? (
          content
        ) : (
          <SuiBox
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{ height: "100%", width: "100%" }}
          >
            <AddIcon fontSize="small" />
            <SuiTypography variant="body2" textTransform="uppercase" fontWeight="bold">
              Create Project
            </SuiTypography>{" "}
          </SuiBox>
        )}
      </SuiBox>
    </Link>
  );
};

export default EmptyProjectCard;
